import { useEffect } from "react";

export default function useSaveRef() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      localStorage.setItem("ref", ref);
      console.log("Đã lưu ref vào localStorage:", ref);
    }
  }, []);
}
